import { CostReviewLink as CostReviewLinkV1 } from './cost-review-link-v1';
import { CostReviewLink as CostReviewLinkV2 } from './cost-review-link-v2';
import { useEnableCostReviewModalRefactor } from '../../feature-flags/hooks/use-enable-cost-review-modal-refactor';

export const CostReviewLinkVersionLoader = ({ className = null, fulfillmentPlanIds, linkDisabled = false, buttonClassName }) => {
  const isCostReviewRefactorEnabled = useEnableCostReviewModalRefactor();

  return isCostReviewRefactorEnabled ? (
    <CostReviewLinkV2
      buttonClassName={buttonClassName}
      className={className}
      fulfillmentPlanIds={fulfillmentPlanIds}
      linkDisabled={linkDisabled}
    />
  ) : (
    <CostReviewLinkV1
      buttonClassName={buttonClassName}
      className={className}
      fulfillmentPlanIds={fulfillmentPlanIds}
      linkDisabled={linkDisabled}
    />
  );
};
